import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-pause-lined",
  "use": "rt-base-circle-pause-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-pause-lined\"><path d=\"M430.5 312h-45.8c-7.2 0-13.1 3.6-13.1 8v384c0 4.4 5.9 8 13.1 8h45.8c7.2 0 13.1-3.6 13.1-8V320c0-4.4-5.9-8-13.1-8zM639.3 312h-45.8c-7.2 0-13.1 3.6-13.1 8v384c0 4.4 5.9 8 13.1 8h45.8c7.2 0 13.1-3.6 13.1-8V320c0-4.4-5.9-8-13.1-8z\" /><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-pause-lined.svg
// module id = 1663
// module chunks = 228